import { MaterialId } from "../const/gadget-material-id";
import { getLastDayFromDate, numberToString_YYYYMMDD_hhmmss } from "./date-util";

/**
 * 定数
 */
export const OP_COUNT_HEATMAP_HEIGHT = 24;  // ヒートマップの縦セル数

/**
 * ヒートマップのx軸セル数算出
 */
export function calcOpCountHeatmapWidth(dimension_material_id: number, current_date: Date) : number
{
  switch( dimension_material_id ){
  case MaterialId.DIMENSION_MONTH:
    return 12;
  case MaterialId.DIMENSION_DATE:
    return getLastDayFromDate( current_date );
  case MaterialId.DIMENSION_DAY_OF_WEEK:
    return 7;
  default:
    console.error(`ヒートマップに対応するDIMENTION(${dimension_material_id})ではありません。`);
    return 0;
  }
}

/**
 * ヒートマップのx軸ラベル生成
 * @return DIMENSION_MONTH, DIMENSION_DATEは日付リスト。DIMENSION_DAY_OF_WEEKは曜日番号リストを返す。
 */
export function genarateOpCountHeatmapLabels(dimension_material_id: number, current_date: Date) : string[]
{
  let labels: string[] = [];

  switch( dimension_material_id ){
  case MaterialId.DIMENSION_MONTH:
    for(let i=0; i<12; ++i ){
      labels.push( numberToString_YYYYMMDD_hhmmss( current_date.getFullYear(), i ) );
    }
    break;
  case MaterialId.DIMENSION_DATE:
    const last_date = getLastDayFromDate( current_date );
    for(let i=1; i<=last_date; ++i ){
      labels.push( numberToString_YYYYMMDD_hhmmss( current_date.getFullYear(), current_date.getMonth(), i ) );
    }
    break;
  case MaterialId.DIMENSION_DAY_OF_WEEK:
    for(let i=0; i<7; ++i ){
      labels.push( `${i}` );
    }
    break;
  default:
    console.error(`ヒートマップに対応するDIMENTION(${dimension_material_id})ではありません。`);
  }

  return labels;
}
